import { render, staticRenderFns } from "./FiltersInvoices.vue?vue&type=template&id=679c1c6b&"
import script from "./FiltersInvoices.vue?vue&type=script&lang=ts&"
export * from "./FiltersInvoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports